import { JWT_STORAGE_KEY } from '@/hooks/use-jwt/use-jwt';
import { closeAll } from '@/services/websocket/ws-client';
import { useCompanyStore, useTimeRangeStore } from '@/store/app.store';
import { DEFAULT_TIME_RANGE } from '@/store/initial-time-range';

/** Whether this browser believes it is signed in. An anonymous visitor has no session to end. */
export function hasStoredSession(): boolean {
  return localStorage.getItem(JWT_STORAGE_KEY) !== null;
}

/**
 * Everything that has to be forgotten when a session ends, in one list.
 *
 * Two callers reach it from different worlds: useLogout, which can use hooks, and the 401
 * interceptor, which runs at module scope and cannot. Keeping the list here is what stops the
 * two drifting — the persisted company and time range in particular would otherwise survive
 * into the next user on whichever path forgot them.
 *
 * Does not navigate and does not clear the React Query cache. Callers own both, because a
 * router push and a full document reload need different treatment.
 */
export function clearSessionState(): void {
  localStorage.removeItem(JWT_STORAGE_KEY);
  // Required, not cleanup: a socket is bounded only by the session's expiry, so signing out
  // does not close it.
  closeAll();
  useCompanyStore.getState().setCompanyName(undefined);
  useTimeRangeStore.getState().setTimeRangeFilter(DEFAULT_TIME_RANGE);
}
